export default "__VITE_ASSET__qPkpSirs__"